// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"50a86810","325":"62b944e7","375":"8f8be049","458":"9da7d331","766":"ee42f3c3","810":"48dda8a7","828":"3da9357f","970":"3bb75745"}[chunkId] + ".chunk.js";
};